import {
	type PresentErrorOptions,
	type PresentedError,
	presentError,
} from "@filosign/errors";
import { showErrorToast } from "@filosign/errors/client";
import { navigateToSupportUrl, SUPPORT_BASE_PATH } from "./support-navigation";

export function presentAppError(
	error: unknown,
	options?: Omit<PresentErrorOptions, "helpBaseUrl">,
): PresentedError {
	return presentError(error, {
		...options,
		helpBaseUrl: SUPPORT_BASE_PATH,
		devMode: import.meta.env.DEV,
	});
}

export function showAppErrorToast(error: unknown): void {
	const presented = presentAppError(error);
	showErrorToast(presented, {
		devMode: import.meta.env.DEV,
		onSupportClick: navigateToSupportUrl,
	});
}
